import { useAccount } from '../contexts/AccountContext';
import axios from 'axios';

/**
 * Custom hook that provides an API call function with automatic account integration
 * @returns {Function} apiCall function that automatically uses the current account
 */
export const useApiCall = () => {
  const { account } = useAccount();
  
  return async (endpoint, method = 'POST', data = null, cancelToken = null) => {
    const API_BASE_URL = process.env.REACT_APP_API_URL;
    const API_KEY = process.env.REACT_APP_API_KEY;

    
    // Construct full URL
    const url = `${API_BASE_URL}${endpoint}`;

    // Prepare headers
    const headers = {
      'Content-Type': 'application/json',
      'api': API_KEY,
      ...(account && account.token && { auth: account.token }),
    };

    // Prepare axios config
    const options = {
      method: method.toUpperCase(),
      url,
      headers,
      ...(data && { data }),
      ...(cancelToken && { signal: cancelToken.signal }),
      timeout: 20000,
    };

    
    return axios(options)
      .then((response) => {
        // Return response data directly
        const responseData = response.data;
        return responseData;
      })
      .catch((error) => {
        if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
          // Silently handle cancellation - just return null or undefined
          return null;
        }
        
        // Return error object with type and message
        return {
          error: true,
          type: error.response?.status || 'network',
          message: error.response?.data?.message || error.message || 'Network error occurred'
        };
      });
  };
};
